import React, { useState, useEffect } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  ReferenceLine,
  Tooltip,
} from "recharts";

const MarginChart = ({ data }) => {
  const [animData, setAnimData] = useState(
    data.map((d) => ({ ...d, cumulative: 0 }))
  );

  useEffect(() => {
    let start = performance.now();
    const duration = 800; // ms

    function animate(time) {
      const t = Math.min((time - start) / duration, 1);
      setAnimData(
        data.map((d) => ({
          ...d,
          cumulative: d.cumulative * t,
        }))
      );
      if (t < 1) {
        requestAnimationFrame(animate);
      }
    }

    // kick off
    requestAnimationFrame(animate);
  }, [data]);

  // decide final stroke color
  const final = data.length ? data[data.length - 1].cumulative : 0;
  const strokeColor = final > 0 ? "#4caf50" : final < 0 ? "#dc3545" : "#ffa500";

  const values = data.map((d) => d.cumulative);
  const maxAbs = Math.max(
    Math.abs(Math.min(...values)),
    Math.abs(Math.max(...values))
  );

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload.length) return null;
    const current = payload[0].value;
    const idx = data.findIndex((d) => d.round === label);
    const prev = idx > 0 ? data[idx - 1].cumulative : 0;
    const delta = current - prev;
    const sign = delta > 0 ? "+" : delta < 0 ? "–" : "";

    return (
      <div
        style={{
          backgroundColor: "#212121",
          border: "1px solid #3f3f3f",
          padding: "8px 12px",
          borderRadius: "4px",
          color: "#fff",
        }}
      >
        <div style={{ fontSize: 12, color: "#aaa" }}>{label}</div>
        <div style={{ fontSize: 14, fontWeight: "bold" }}>
          {sign}
          {Math.abs(delta)}
        </div>
      </div>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={100}>
      <LineChart
        data={animData}
        margin={{ top: 5, right: 10, left: -25, bottom: -10 }}
      >
        <XAxis
          dataKey="round"
          padding={{ left: 0, right: 0 }}
          tick={{ fill: "#aaa", fontSize: 0 }}
          axisLine={{ stroke: "#3f3f3f" }}
          tickLine={false}
          isAnimationActive={false}
        />
        <YAxis
          domain={[-maxAbs, maxAbs]}
          ticks={[-maxAbs, 0, maxAbs]}
          tick={{ fill: "#aaa", fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          isAnimationActive={false}
        />
        <ReferenceLine y={0} stroke="#888" strokeDasharray="3 3" />
        <Tooltip content={(props) => <CustomTooltip {...props} />} />
        <Line
          type="monotone"
          dataKey="cumulative"
          stroke={strokeColor}
          strokeWidth={2}
          dot={{ r: 4, stroke: "#212121", strokeWidth: 1, fill: strokeColor }}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default MarginChart;
